import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Contacts from "./pages/Contacts";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CCPA from "./pages/CCPA";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";
import CookiesPlolicy from "./pages/CookiesPlolicy";
import Promotion from "./pages/Promotion";
import Forms1099 from "./pages/Forms1099";
import FormsW2 from "./pages/FormsW2";
import FormsPayroll from "./pages/FormsPayroll";
import FormsACA from "./pages/FormsACA";
import FormExtensions from "./pages/FormsExtensions";

function App() {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Home/>,
        },
        {
            path: "/1099-forms",
            element: <Forms1099/>,
        },
        {
            path: "/w2-forms",
            element: <FormsW2/>,
        },
        {
            path: "/payroll-forms",
            element: <FormsPayroll/>,
        },
        {
            path: "/aca-forms",
            element: <FormsACA/>,
        },
        {
            path: "/tax-extensions",
            element: <FormExtensions/>,
        },
        {
            path: "/contact-us",
            element: <Contacts/>,
        },
        {
            path: "/promo",
            element: <Promotion/>,
        },
        {
            path: "/privacy-policy",
            element: <PrivacyPolicy/>,
        },
        {
            path: "/ccpa",
            element: <CCPA/>,
        },
        {
            path: "/terms",
            element: <Terms/>,
        },
        {
            path: "/cookies-policy",
            element: <CookiesPlolicy/>,
        },
        {
            path: "*",
            element: <NotFound/>,
        },
    ]);
  return (
      <RouterProvider router={router} />


  );
}

export default App;
